import React, { useEffect, useRef, useState } from "react";
import { Modal } from "../modal/Modal";
import { BloqueHome } from "./bloques/BloqueHome";
import { BloqueHomeAcciones } from "./bloques/BloqueHomeAcciones";
import { HeroHome } from "./hero/heroHome";
import { NovedadesHome } from "./novedades/NovedadesHome";
import { PlanesSlider } from "./planesSlider/planesSlider";
import { VideoHome } from "./video/VideoHome";
import { PromoTitles } from "./promoTitles/PromoTitles";

export const HomeScreen = () => {
    const [promoTiles, setPromoTiles] = useState([]);

    useEffect(() => {
        const getPromoTiles = async () => {
            const response = await fetch("/getPromos");
            const result = await response.json();
            if (result.estado === 0) return;

            setPromoTiles(result);
        };

        getPromoTiles();
    }, []);

    return (
        <div className="position-relative">
            <Modal />
            <HeroHome />
            <BloqueHome />
            <PlanesSlider />
            <PromoTitles promoTiles={promoTiles} />
            <BloqueHomeAcciones />
            <VideoHome />
            <NovedadesHome />
        </div>
    );
};
